var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.69212 15.7992H0.457908V5.38399H3.69212V15.7992ZM2.07307 3.96328C1.03901 3.96328 0.199951 3.10639 0.199951 2.07233C0.199951 1.57555 0.397297 1.09912 0.748574 0.747841C1.09985 0.396564 1.57628 0.199219 2.07307 0.199219C2.56985 0.199219 3.04628 0.396564 3.39756 0.747841C3.74883 1.09912 3.94618 1.57555 3.94618 2.07233C3.94618 3.10639 3.10712 3.96328 2.07307 3.96328ZM15.7966 15.7992H12.5696V10.7292C12.5696 9.52078 12.5451 7.97136 10.8882 7.97136C9.20672 7.97136 8.94876 9.28399 8.94876 10.6423V15.7992H5.71789V5.38399H8.81951V6.8047H8.86464C9.29642 5.98626 10.3511 5.12269 11.9245 5.12269C15.1977 5.12269 15.7994 7.27828 15.7994 10.0779V15.7992H15.7966Z",
    fill: "#D6E0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.4da214a9a03fd630794d898ed6bba461.svg";
export { ForwardRef as ReactComponent };